import {Injectable} from '@angular/core';
import {User} from 'firebase';
import {Router} from '@angular/router';
import {AngularFireAuth} from '@angular/fire/auth';
import { from } from 'rxjs';
import {Observable} from 'rxjs/Observable';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    public user: User;

    public token: string;

    constructor(public  afAuth: AngularFireAuth, public  router: Router) {
        this.afAuth.authState.subscribe(user => {
            if (user) {
                this.user = user;
                localStorage.setItem('user', JSON.stringify(this.user));
            } else {
                localStorage.setItem('user', null);
            }
        })
    }

    signupUser(email: string, password: string) {
        // your code for signing up the new user
    }

    signinUser(email: string, password: string): Observable<any> {
        // your code for checking credentials and getting tokens for for signing in user
       return from(
            this.afAuth.auth.signInWithEmailAndPassword(email, password)
       );
    }

    logout() {
        this.token = null;
        this.afAuth.auth.signOut();
        localStorage.removeItem('user');
        this.router.navigate(['admin/login']);
    }

    getToken() {
        return this.token;
    }

    isAuthenticated() {
        // here you can check if user is authenticated or not through his token
        const  user  =  JSON.parse(localStorage.getItem('user'));
       // return  user  !==  null;
        return true;
    }
}
